import { Component, OnInit } from '@angular/core';
import { BannerManagementService } from '../../services/banner-management.service';
import { BannerDTO } from '../../interfaces/banner-management/banner-dto.interface';
import { BannerDisplayTypeEnum } from '../../enums/banner-management/banner-display-type.enum';
import { IBannerFilter } from '../../interfaces/banner-management/banner-filter.interface';
import { flatten } from '../../utils/flatten';
import { BannerTypeEnum } from '../../enums/banner-management/banner-type.enum';
import { UserService } from 'src/app/services';

@Component({
  templateUrl: './banner-management-container.component.html',
  styleUrls: ['./banner-management-container.component.scss'],
})
export class BannerManagementContainerComponent implements OnInit {
  public bannerType = BannerTypeEnum;

  editMode = false;
  editBannerDTO: BannerDTO;

  filter: IBannerFilter = { filters: {} };

  banners: Map<BannerTypeEnum, BannerDTO[]> = new Map<BannerTypeEnum, BannerDTO[]>();

  isBannerAdministrator: boolean;

  selectedTab: number;

  constructor(
    private bannerManagementService: BannerManagementService,
    private userService: UserService,
  ) {}

  async ngOnInit() {
    this.onReloadBanners();
    this.isBannerAdministrator = await this.userService.isUserInRole('BADM');
  }

  loadActiveBanners() {
    this.filter.filters = {
      upcomingOnly: { value: false },
      displayType: { value: BannerDisplayTypeEnum.ActiveOrScheduled },
    };

    this.bannerManagementService.getBanners(flatten(this.filter)).then((res) => {
      this.banners.set(BannerTypeEnum.Active, res);
      //console.log("ACTIVE BANNERS: ", res);
    });
  }

  loadDraftBanners() {
    this.filter.filters = {
      upcomingOnly: { value: false },
      displayType: { value: BannerDisplayTypeEnum.Draft },
    };

    this.bannerManagementService.getBanners(flatten(this.filter)).then((res) => {
      this.banners.set(BannerTypeEnum.Draft, res);
      //console.log("DRAFT BANNERS: ", res);
    });
  }

  loadUpcomingBanners() {
    this.filter.filters = {
      upcomingOnly: { value: true },
      displayType: { value: BannerDisplayTypeEnum.ActiveOrScheduled },
    };

    this.bannerManagementService.getBanners(flatten(this.filter)).then((res) => {
      this.banners.set(BannerTypeEnum.Upcoming, res);
      //console.log("UPCOMING BANNERS: ", res);
    });
  }

  createBanner() {
    this.editBannerDTO = null;
    this.editMode = true;
  }

  onBannerEditFinished(savedBanner?: BannerDTO) {
    this.editMode = false;

    // reload all banners
    this.onReloadBanners();
  }

  onReloadBanners() {
    //console.log('Reload banners..');

    this.loadActiveBanners();
    this.loadUpcomingBanners();
    this.loadDraftBanners();
  }

  onEditBanner(banner: BannerDTO) {
    this.editBannerDTO = banner;
    this.editMode = true;
  }
}
